/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiBulkCloseCommand,
    InternalApiBulkCloseCommandFromJSON,
    InternalApiBulkCloseCommandToJSON,
} from '../models';

export interface BulkUpdateRequest {
    internalApiBulkCloseCommand: InternalApiBulkCloseCommand;
}

/**
 * 
 */
export class BulkAlertStatusApi extends runtime.BaseAPI {

    /**
     * Update status for many alerts at a time
     */
    async bulkUpdateRaw(requestParameters: BulkUpdateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.internalApiBulkCloseCommand === null || requestParameters.internalApiBulkCloseCommand === undefined) {
            throw new runtime.RequiredError('internalApiBulkCloseCommand','Required parameter requestParameters.internalApiBulkCloseCommand was null or undefined when calling bulkUpdate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/alerts/bulk-status`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiBulkCloseCommandToJSON(requestParameters.internalApiBulkCloseCommand),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update status for many alerts at a time
     */
    async bulkUpdate(requestParameters: BulkUpdateRequest, initOverrides?: RequestInit): Promise<void> {
        await this.bulkUpdateRaw(requestParameters, initOverrides);
    }

}
